var _g, _line, _path, _polygon, _polygon2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnPlatformOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    d: "M46.48,24v0.289c-0.027,1.961-0.289,3.934-0.84,5.824 c-0.512,1.891-1.297,3.711-2.32,5.383c-0.992,1.695-2.223,3.258-3.629,4.625c-1.395,1.379-2.996,2.567-4.707,3.504 c-1.711,0.98-3.547,1.711-5.449,2.18c-1.906,0.5-3.879,0.734-5.84,0.691c-1.958-0.016-3.918-0.305-5.808-0.844 c-1.891-0.523-3.715-1.309-5.395-2.316c-1.699-0.996-3.246-2.223-4.609-3.645C6.5,38.297,5.312,36.711,4.358,35 c-0.964-1.715-1.695-3.562-2.164-5.465c-0.496-1.891-0.73-3.867-0.691-5.824c0.016-1.973,0.293-3.934,0.844-5.813 c0.511-1.902,1.297-3.711,2.32-5.395c0.992-1.699,2.207-3.258,3.625-4.609c1.395-1.383,2.98-2.567,4.707-3.52 c1.711-0.969,3.547-1.711,5.453-2.18c1.902-0.496,3.863-0.73,5.836-0.691c1.961,0.016,3.918,0.305,5.813,0.844 c1.891,0.523,3.709,1.312,5.395,2.316c1.699,0.996,3.246,2.223,4.609,3.645c1.383,1.394,2.566,2.98,3.52,4.707 c0.969,1.695,1.695,3.547,2.168,5.449C46.273,20.273,46.512,22.137,46.48,24"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.9968,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 11.914,
    y1: 31.887,
    x2: 35.16,
    y2: 31.887
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.25,31.887c0,1.273-1.031,2.305-2.305,2.305c-1.27,0-2.301-1.031-2.301-2.305 c0-1.27,1.031-2.301,2.301-2.301C35.219,29.586,36.25,30.617,36.25,31.887z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "21.535,14.344 13.983,20.141 21.535,25.941 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.8753,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "21.535,14.344  13.983,20.141 21.535,25.941 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.026,
    y: 17.906,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    width: 11.704,
    height: 4.473
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.026,
    y: 17.906,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.7721,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    width: 11.704,
    height: 4.473
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPlatformOut);
export default __webpack_public_path__ + "static/media/btnPlatformOut.00144258def37e958890a88d99e41df8.svg";
export { ForwardRef as ReactComponent };